import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;
  p {
    text-align: justify;
  }
  .banner {
    height: 300px;
    background-image: url('assets/images/actualite.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.5);
      width: 100%;
      height: 100%;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 17px;
        padding: 12px 10px;
        margin-right: 15px;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 5% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
      color: ${YELLOW};
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      // background-color: green;
    }
  }
`;

export const TheoriePage = () => {
  // const history = useHistory();
  // const [option, setOption] = useState('1');

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10}>
              <Image
                alt='moranje-logo'
                src='assets/images/moranje-logo.png'
                width={130}
                preview={false}
                style={{ objectFit: 'contain' }}
              />
              <div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 35,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 30,
                  }}
                >
                  PRÉSENTATION GÉNÉRALE DU MARCHÉ DES TITRES PUBLICS
                </div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item>
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Courbes des Taux</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Théorie</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />
          </div>
        </div>

        <div className='content'>
          <h3>Contexte de création du marché des titres publics de la CEMAC</h3>
          <p>
            Depuis son lancement en novembre 2011, le marché des titres publics
            émis par adjudication, organisée par la BEAC a vu l’entrée
            respectivement du Cameroun le 23 novembre 2011, de la Centrafrique
            le 28 décembre 2011, du Gabon le 8 mai 2013, du Tchad le 22 octobre
            2014, de la Guinée équatoriale le 9 septembre 2015 et du Congo le 22
            février 2017. La BEAC depuis quelques années s’est engagée dans une
            série de réformes visant à dynamiser le marché monétaire de la
            CEMAC. L’une d’entre elles est la suppression progressive des
            avances aux Etats membres de la CEMAC. En contrepartie, il s’est
            imposé la nécessité de promouvoir le marché des titres publics
            régional, cadre alternatif aux Etats permettant de mobiliser des
            ressources pour la couverture de leurs besoins de financement.
          </p>
          <p>
            Le marché régional des titres publics repose sur le mécanisme
            d’émission des titres publics selon lequel les adjudications des
            valeurs du Trésor s’effectuent par voie d’appel d’offres, organisées
            par la Direction nationale de la BEAC du pays émetteur.
          </p>
          <h3>
            Objectifs visés par la mise en place du marché des titres publics de
            la CEMAC
          </h3>
          <p>
            <ul>
              <li>
                Collecter davantage de ressources que dans le système des
                avances directes de la Banque Centrale aux Trésors ;
              </li>
              <li>
                Permettre aux entreprises et aux particuliers de souscrire à des
                instruments financiers rentables, peu risqués et liquides par le
                canal des institutions habilités ;
              </li>
              <li>
                Permettre aux établissements de crédit de placer à des taux
                d’intérêt intéressants leurs liquidités oisives déposées à la
                BEAC ;
              </li>
              <li>
                Contribuer à l’approfondissement du volet titres publics du
                marché financier régional ;
              </li>
              <li>
                Contenir les pressions inflationnistes que les tirages sur les
                ressources monétaires sont susceptibles d’engendrer ;
              </li>
              <li>
                Donner à la politique monétaire une plus grande marge de
                flexibilité et constituer un stock suffisant de titres servant
                de support à la politique d’open market ;
              </li>
              <li>
                Elargir la gamme des supports de placement des épargnants et des
                investisseurs ;
              </li>
              <li>
                Moderniser le mode de financement des Trésors publics en passant
                d’un système statique de gestion de la dette à un système plus
                dynamique et plus performant, pouvant permettre de mieux
                maîtriser les coûts et les risques afférents à l’endettement
                public ;
              </li>
            </ul>
          </p>
          <h3>
            Caractéristiques des titres et acteurs du marché des titres publics
          </h3>
          <p>
            Les titres émis sur ce marché sont dématérialisés et assimilables.
            Il s’agit des Bons du Trésor Assimilables (BTA) et des Obligations
            du Trésor Assimilables (OTA) dont les caractéristiques se déclinent
            comme suit :
          </p>
          <ul>
            <li>
              les OTA, émises pour des durées supérieures ou égales à deux ans,
              pour une valeur nominale de 10 000 francs CFA et dont les intérêts
              sont payables annuellement.
            </li>
            <li>
              les BTA, émis pour des durées de 13, 26 et 52 semaines, dont la
              valeur nominale est fixée à 1 million de francs CFA et dont les
              intérêts sont précomptés ;
            </li>
          </ul>
          <p>
            <b>NB</b> : ces titres sont directement admis comme collatéral au
            refinancement de la BEAC.
          </p>
          <h3>Acteurs du marché et leur rôle</h3>
          <p>
            Les principaux acteurs animant le marché des titres publics sont :
            <ul>
              <li>les six Trésors nationaux, comme émetteurs ;</li>
              <li>
                les Spécialistes en Valeurs du Trésor (SVT) qui sont les
                établissements de crédit agréés, comme teneurs du marché ;
              </li>
              <li>
                les Directions Nationales de la BEAC, en charge de
                l’organisation matérielle des adjudications ;
              </li>
              <li>
                les investisseurs : personnes physiques et morales résidentes et
                non résidentes ;
              </li>
              <li>
                la CRCT, en qualité de Dépositaire Central et en charge de la
                codification, de la conservation, de l’administration des titres
                et du règlement/livraison.
              </li>
            </ul>
          </p>
          <h3>Segmentation du marché</h3>
          <p>
            A l’instar des autres marchés, le marché des titres publics émis par
            adjudication de la CEMAC comprend deux compartiments :
          </p>
          <ul>
            <li>
              un marché secondaire où s’échangent les titres après leur
              émission. Sur ce compartiment, les SVT sont tenus d’afficher à
              leurs guichets les cours d’achat et de vente des valeurs du
              Trésor, et de vendre ou d’acheter aux prix affichés, à la demande
              de tout investisseur potentiel, conformément à la réglementation.
            </li>
            <li>
              un marché primaire où sont placés les titres publics nouvellement
              émis. Il est réservé exclusivement aux Spécialistes en Valeurs du
              Trésor (SVT). En contrepartie, ces derniers ont l’obligation de
              placer tout ou partie des acquis auprès de leur utilisateurèle. Les
              émissions de titres s’effectuent par voie d’adjudication,
              organisée par la BEAC ;
            </li>
          </ul>
          <p>
            Les émissions se font par voie d’adjudication selon un calendrier
            bien défini par chaque Trésor national :
          </p>
          <ul>
            <li>les BTA avec une fréquence hebdomadaire;</li>
            <li>les OTA avec une fréquence mensuelle.</li>
          </ul>
          <p>
            <b>Sources: </b>
            <a href='https://www.beac.int/m-des-titres-publics/presentation-generale/'>
              BEAC:Présentation Générale du Marché des Titres Publics
            </a>
          </p>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
